<template>
  <div class="content c895">
    <h2>Sušilni stroj 1</h2>
  </div>
  <div class="content c590">
    <div class="popup popDev7" style="display:none;">
      <div class="inner">
        <h3>Ali ste prepričani, da želite izbrisati napravo?</h3>
        <div class="msg">
          <h3>Sušilni stroj</h3>
        </div>
        <div class="con">
          <p>Izbrišite napravo, če ste se zmotili pri njenih podatkih oziroma ste izbrali napačno napravo. Če bi želeli, jo lahko kasneje brez težav ponovno dodate.</p>
        </div>
        <div class="btns">
          <a
            href="javascript:void(0)"
            class="btn"
            title="Več"
            onclick="popupDelete(&quot;popDev7&quot;)"
          >NE, PREKLIČI</a>
          <a
            id="ctl00_ContentPlaceHolder1_lnkBtnDeleteDevice"
            class="btn"
            href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$lnkBtnDeleteDevice','')"
          >DA, IZBRIŠI</a>
        </div>
      </div>
    </div>
    <div class="appliance">
      <table>
        <tbody>
          <tr>
            <td class="first">Sušilni stroj</td>
            <td>A++</td>
            <td class="last">
              <div class="tools">
                <a
                  href="javascript:void(0)"
                  title="Zbriši"
                  class="close"
                  onclick="popupDelete(&quot;popDev7&quot;)"
                >Zbriši</a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="appliance data">
      <div class="icon">
        <span class="SS">Sušilni stroj</span>
      </div>
      <div class="first">
        <h5>TRENUTNA PORABA</h5>
        <span id="ctl00_ContentPlaceHolder1_lblConsumption">
          <span class="et">
            192 kWh / leto
            <div class="tooltip-bottom">
              Enotna tarifa (ET) je tarifa, ki jo beleži enotarifni števec vsak dan od 0.00 do 24.00 ure. Cena električne energije je ves čas enaka. V primeru, da imate enotarifno merjenje in želite dvotarifnega, pokličite v vaše elektrodistribucijsko podjetje za podrobnejše informacije.
              <br />
              <a
                href="http://www.uresnicujmo.si/o_aplikaciji_za_izracun_prihrankov/predstavitev#tarife"
                target="_blank"
                title="Več"
              >Več o tem &gt;</a>
            </div>
          </span>
        </span>
        <em>
          <span id="ctl00_ContentPlaceHolder1_lblTotalPrice">14,52 € / leto</span>
        </em>
      </div>

      <div class="no-data">
        <h5>VAŠI PRIHRANKI VAŠA NOVA PORABA</h5>
        <div class="message">
          <p>Za izračun nove porabe in prihrankov na izbrani napravi izvedi vsaj en ukrep.</p>
        </div>
      </div>
    </div>
    <div class="actions">
      <div class="toggle-btn" style="display:none;">
        <a href="javascript:void(0)" class="active">Prihranki zaradi izvedenih ukrepov</a>
      </div>
      <ul class="actionsExistingUl"></ul>

      <h3>Zmanjšajte porabo naprave Sušilni stroj</h3>
      <p>Zmanjšajte porabo tako, da izvedete vsaj enega, še bolje pa več, spodaj navedenih ukrepov. Izberite le tiste, ki so v vaših razmerah pomembni.</p>
      <ul>
        <li id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_divAction">
          <a
            class="actionBtnMore active"
            style="cursor:pointer;"
          >Zamenjamo naš stari sušilni stroj z novim, ki je energetsko bolj učinkovit</a>

          <div style class="actionPnlMore">
            <div id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_Panel4">
              <div class="form">
                <h3>Izberite lastnosti novega Sušilnega stroja:</h3>
                <fieldset>
                  <div class="f-item select">
                    <label>
                      Energijski razred:
                      <span>(oz. leto izdelave naprave)</span>
                    </label>
                    <span
                      id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_RequiredFieldValidator2"
                      style="color:Red;float:none;font-size:1em;visibility:hidden;"
                    >*</span>
                    <select
                      name="ctl00$ContentPlaceHolder1$RepeaterActions$ctl00$ddlClassDryer"
                      id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_ddlClassDryer"
                    >
                      <option value="0">Izberite</option>
                      <option value="85">A (od 2010 dalje)</option>
                      <option value="180">A++</option>
                      <option value="86">B (2007-2009)</option>
                      <option value="87">C (2007)</option>
                      <option value="88">D (pred 2007)</option>
                      <option value="89">E (pred 2007)</option>
                      <option value="90">F (pred 2007)</option>
                    </select>
                    <!-- tooltip + div added-->
                    <div class="help">
                      <a href="#" class="help" title="Help">Help</a>
                      <div
                        class="tooltip"
                      >V mestnih gospodinjstvih je sušilni stroj skoraj obvezna oprema, na njegovo porabo pa močno vpliva kakovost aparata, zato je najbolje izbrati višje varčne razrede.</div>
                    </div>
                    <!-- //end -->
                  </div>
                </fieldset>
              </div>
            </div>

            <div class="advice">
              <div class="right">
                <a
                  id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_lnkBtnAdd"
                  class="btn"
                  href="javascript:WebForm_DoPostBackWithOptions(new WebForm_PostBackOptions(&quot;ctl00$ContentPlaceHolder1$RepeaterActions$ctl00$lnkBtnAdd&quot;, &quot;&quot;, true, &quot;ChangeDevice&quot;, &quot;&quot;, false, true))"
                >Izvedi ukrep</a>
              </div>
              <p>Na porabo sušilnega stroja primarno vpliva njegova starost in s tem povezana energijska učinkovitost in način delovanja – novejši stroji s toplotno črpalko so energetsko varčnejši od kondenzacijskih strojev. Če imamo torej starejši stroj ali kondenzacijski stroj, je priporočljivo, da kupimo novega, ki ima čim boljši energetski razred (B ali A). S tem bomo povečali prihranke na tej napravi.</p>
            </div>
          </div>
        </li>

        <li id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl01_divAction">
          <a
            class="actionBtnMore"
            style="cursor:pointer;"
          >Uporabljajmo program, ki deluje na podlagi vlažnosti perila</a>

          <div style="display:none;" class="actionPnlMore">
            <div class="advice">
              <div class="right">
                <a
                  id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl01_lnkBtnAdd"
                  class="btn"
                  href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$RepeaterActions$ctl01$lnkBtnAdd','')"
                >Izvedi ukrep</a>
              </div>
              <p>Uporabljajmo program, ki deluje na podlagi vlažnosti perila, namesto programa, ki deluje na osnovi časovne nastavitve dolžine sušenja - torej če ne presušimo perila, lahko prihranimo okoli 15 % električne energije.</p>
            </div>
          </div>
        </li>

        <li id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl02_divAction">
          <a
            class="actionBtnMore"
            style="cursor:pointer;"
          >Uporabljajmo sušilni stroj z vgrajeno toplotno črpalko</a>

          <div style="display:none;" class="actionPnlMore">
            <div class="advice">
              <div class="right">
                <a
                  id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl02_lnkBtnAdd"
                  class="btn"
                  href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$RepeaterActions$ctl02$lnkBtnAdd','')"
                >Izvedi ukrep</a>
              </div>
              <p>Večina sušilnih strojev je v energijskem razred B - to so klasični sušilni stroji z električnim grelcem. Smiselno je uporabljati sušilni stroji s toplotno črpalko, ki je najvarčnejši, in sodi v energijski razred A. Pri tem lahko prihranimo do 40 % električne energije.</p>
            </div>
          </div>
        </li>

        <li id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl03_divAction">
          <a class="actionBtnMore" style="cursor:pointer;">Sušimo le v času nižje tarife (MT)</a>

          <div style="display:none;" class="actionPnlMore">
            <div class="advice">
              <div class="right">
                <a
                  id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl03_lnkBtnAdd"
                  class="btn"
                  href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$RepeaterActions$ctl03$lnkBtnAdd','')"
                >Izvedi ukrep</a>
              </div>
              <p>
                Če perilo sušimo le
                <a
                  href="http://www.uresnicujmo.si/o_aplikaciji_za_izracun_prihrankov#tarife"
                  target="_blank"
                >v času nižje tarife</a>, lahko v primerjavi s sušenjem le v času višje tarife (VT) prihranimo na stroških porabljene energije, ki jo porabi samo sušilni stroj, okoli 30 %.
              </p>
            </div>
          </div>
        </li>

        <li id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl04_divAction">
          <a
            class="actionBtnMore"
            style="cursor:pointer;"
          >Sušilni stroj izklopimo ali povsem odstranimo</a>

          <div style="display:none;" class="actionPnlMore">
            <div class="advice">
              <div class="right">
                <a
                  id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl04_lnkBtnAdd"
                  class="btn"
                  href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$RepeaterActions$ctl04$lnkBtnAdd','')"
                >Izvedi ukrep</a>
              </div>
              <p>Premislite, ali sušilni stroj res potrebujete. Če imate balkon, lahko vsaj v poletnem času perilo posuši sonce. Z izklopom sušilnega stroja boste znatno znižali porabo električne energije.</p>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="advice">
      <h4>Imejte vedno v mislih, da lahko prihranite!</h4>
      <p>Zgornji ukrepi so merljivi in ob njihovem izvajanju točno veste, koliko energije lahko prihranite. Toda za vse električne naprave v gospodinjstvu, tako večje kot majhne, smo zbrali še kopico nasvetov, ki vam lahko pomagajo dodatno prihraniti, čeprav prihranka zaradi različnosti naprav in situacij za te nasvete ni mogoče količinsko opredeliti.</p>
      <a
        href="http://www.uresnicujmo.si/nasveti/hladilnik"
        target="_blank"
        alt="več"
        class="more"
      >PREBERITE NASVETE</a>
    </div>
  </div>
  <div class="content r-c">
    <div class="c282">
      <h3>PORABA NAPRAVE SUŠILNI STROJ 1</h3>
      <div class="select">
        <select
          name="ctl00$ContentPlaceHolder1$ddlUsageType"
          onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageType\',\'\')', 0)"
          id="ctl00_ContentPlaceHolder1_ddlUsageType"
          class="s156"
        >
          <option selected="selected" value="1">Kumulativna poraba (€)</option>
          <option value="2">Kumulativna poraba (kWh)</option>
        </select>
        <select
          name="ctl00$ContentPlaceHolder1$ddlUsageTSpan"
          onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageTSpan\',\'\')', 0)"
          id="ctl00_ContentPlaceHolder1_ddlUsageTSpan"
        >
          <option selected="selected" value="1">za 1 leto</option>
          <option value="5">za 5 let</option>
          <option value="10">za 10 let</option>
          <option value="15">za 15 let</option>
        </select>
      </div>

      <div class="graph">
        <div class="chart">
          <div
            id="ctl00_ContentPlaceHolder1_divCurrentUsage"
            class="col without"
            style="height:100%;"
          >
            <span id="ctl00_ContentPlaceHolder1_lblCurrentUsage">14,52 €</span>
          </div>
        </div>
        <div class="legend">
          <div class="col">
            <strong>Poraba brez</strong> izvedenih ukrepov
          </div>
          <div class="col">
            <strong>Poraba z</strong> izvedenimi ukrepi
          </div>
        </div>
      </div>
    </div>
    <div class="c282">
      <h3>PORABA NAPRAVE SUŠILNI STROJ 1</h3>
      <div class="select">
        <select
          name="ctl00$ContentPlaceHolder1$ddlUsageType2"
          onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageType2\',\'\')', 0)"
          id="ctl00_ContentPlaceHolder1_ddlUsageType2"
          class="s156"
        >
          <option selected="selected" value="1">Kumulativna poraba (€)</option>
          <option value="2">Kumulativna poraba (kWh)</option>
        </select>
        <select
          name="ctl00$ContentPlaceHolder1$ddlUsageTSpan2"
          onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageTSpan2\',\'\')', 0)"
          id="ctl00_ContentPlaceHolder1_ddlUsageTSpan2"
        >
          <option value="1">za 1 leto</option>
          <option selected="selected" value="5">za 5 let</option>
          <option value="10">za 10 let</option>
          <option value="15">za 15 let</option>
        </select>
      </div>
      <div class="graph image">
        <div class="chart">
          <img
            id="ctl00_ContentPlaceHolder1_Chart1"
            src="/Images/Charts/Chart000004.png?d4ef8c61-c120-4243-b40e-172725ddeb95"
            alt
            usemap="#ctl00_ContentPlaceHolder1_Chart1ImageMap"
            style="height:168px;width:263px;border-width:0px;padding:0;"
          />
          <map
            name="ctl00_ContentPlaceHolder1_Chart1ImageMap"
            id="ctl00_ContentPlaceHolder1_Chart1ImageMap"
          >
            <area
              shape="poly"
              coords="198, 144, 198, 45, 198, 45, 257, 20, 257, 20, 257, 144, 198, 144"
              title="13.11.2025; 72,612722"
              alt
            />
            <area
              shape="poly"
              coords="139, 144, 139, 70, 139, 70, 198, 45, 198, 45, 198, 144, 139, 144"
              title="13.11.2024; 58,0901776"
              alt
            />
            <area
              shape="poly"
              coords="81, 144, 81, 94, 81, 94, 139, 70, 139, 70, 139, 144, 81, 144"
              title="13.11.2023; 43,5676332"
              alt
            />
            <area
              shape="poly"
              coords="22, 144, 22, 119, 22, 119, 81, 94, 81, 94, 81, 144, 22, 144"
              title="13.11.2022; 29,0450888"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 20, 257, 20, 22, 119, 22, 119, 22, 144, 257, 144"
              title="13.11.2021; 14,5225444"
              alt
            />
            <area
              shape="poly"
              coords="198, 144, 198, 45, 198, 45, 257, 20, 257, 20, 257, 144, 198, 144"
              title="13.11.2025; 72,612722"
              alt
            />
            <area
              shape="poly"
              coords="139, 144, 139, 70, 139, 70, 198, 45, 198, 45, 198, 144, 139, 144"
              title="13.11.2024; 58,0901776"
              alt
            />
            <area
              shape="poly"
              coords="81, 144, 81, 94, 81, 94, 139, 70, 139, 70, 139, 144, 81, 144"
              title="13.11.2023; 43,5676332"
              alt
            />
            <area
              shape="poly"
              coords="22, 144, 22, 119, 22, 119, 81, 94, 81, 94, 81, 144, 22, 144"
              title="13.11.2022; 29,0450888"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 20, 257, 20, 22, 119, 22, 119, 22, 144, 257, 144"
              title="13.11.2021; 14,5225444"
              alt
            />
            <area
              shape="poly"
              coords="198, 144, 198, 45, 198, 45, 257, 20, 257, 20, 257, 144, 198, 144"
              title="13.11.2025; 72,612722"
              alt
            />
            <area
              shape="poly"
              coords="139, 144, 139, 70, 139, 70, 198, 45, 198, 45, 198, 144, 139, 144"
              title="13.11.2024; 58,0901776"
              alt
            />
            <area
              shape="poly"
              coords="81, 144, 81, 94, 81, 94, 139, 70, 139, 70, 139, 144, 81, 144"
              title="13.11.2023; 43,5676332"
              alt
            />
            <area
              shape="poly"
              coords="22, 144, 22, 119, 22, 119, 81, 94, 81, 94, 81, 144, 22, 144"
              title="13.11.2022; 29,0450888"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 20, 257, 20, 22, 119, 22, 119, 22, 144, 257, 144"
              title="13.11.2021; 14,5225444"
              alt
            />
            <area
              shape="poly"
              coords="198, 144, 198, 45, 198, 45, 257, 20, 257, 20, 257, 144, 198, 144"
              title="13.11.2025; 72,612722"
              alt
            />
            <area
              shape="poly"
              coords="139, 144, 139, 70, 139, 70, 198, 45, 198, 45, 198, 144, 139, 144"
              title="13.11.2024; 58,0901776"
              alt
            />
            <area
              shape="poly"
              coords="81, 144, 81, 94, 81, 94, 139, 70, 139, 70, 139, 144, 81, 144"
              title="13.11.2023; 43,5676332"
              alt
            />
            <area
              shape="poly"
              coords="22, 144, 22, 119, 22, 119, 81, 94, 81, 94, 81, 144, 22, 144"
              title="13.11.2022; 29,0450888"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 20, 257, 20, 22, 119, 22, 119, 22, 144, 257, 144"
              title="13.11.2021; 14,5225444"
              alt
            />
            <area
              shape="poly"
              coords="198, 144, 198, 45, 198, 45, 257, 20, 257, 20, 257, 144, 198, 144"
              title="13.11.2025; 72,612722"
              alt
            />
            <area
              shape="poly"
              coords="139, 144, 139, 70, 139, 70, 198, 45, 198, 45, 198, 144, 139, 144"
              title="13.11.2024; 58,0901776"
              alt
            />
            <area
              shape="poly"
              coords="81, 144, 81, 94, 81, 94, 139, 70, 139, 70, 139, 144, 81, 144"
              title="13.11.2023; 43,5676332"
              alt
            />
            <area
              shape="poly"
              coords="22, 144, 22, 119, 22, 119, 81, 94, 81, 94, 81, 144, 22, 144"
              title="13.11.2022; 29,0450888"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 20, 257, 20, 22, 119, 22, 119, 22, 144, 257, 144"
              title="13.11.2021; 14,5225444"
              alt
            />
            <area
              shape="poly"
              coords="198, 144, 198, 45, 198, 45, 257, 20, 257, 20, 257, 144, 198, 144"
              title="13.11.2025; 72,612722"
              alt
            />
            <area
              shape="poly"
              coords="139, 144, 139, 70, 139, 70, 198, 45, 198, 45, 198, 144, 139, 144"
              title="13.11.2024; 58,0901776"
              alt
            />
            <area
              shape="poly"
              coords="81, 144, 81, 94, 81, 94, 139, 70, 139, 70, 139, 144, 81, 144"
              title="13.11.2023; 43,5676332"
              alt
            />
            <area
              shape="poly"
              coords="22, 144, 22, 119, 22, 119, 81, 94, 81, 94, 81, 144, 22, 144"
              title="13.11.2022; 29,0450888"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 20, 257, 20, 22, 119, 22, 119, 22, 144, 257, 144"
              title="13.11.2021; 14,5225444"
              alt
            />
            <area
              shape="poly"
              coords="198, 144, 198, 45, 198, 45, 257, 20, 257, 20, 257, 144, 198, 144"
              title="13.11.2025; 72,612722"
              alt
            />
            <area
              shape="poly"
              coords="139, 144, 139, 70, 139, 70, 198, 45, 198, 45, 198, 144, 139, 144"
              title="13.11.2024; 58,0901776"
              alt
            />
            <area
              shape="poly"
              coords="81, 144, 81, 94, 81, 94, 139, 70, 139, 70, 139, 144, 81, 144"
              title="13.11.2023; 43,5676332"
              alt
            />
            <area
              shape="poly"
              coords="22, 144, 22, 119, 22, 119, 81, 94, 81, 94, 81, 144, 22, 144"
              title="13.11.2022; 29,0450888"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 20, 257, 20, 22, 119, 22, 119, 22, 144, 257, 144"
              title="13.11.2021; 14,5225444"
              alt
            />
            <area
              shape="poly"
              coords="198, 144, 198, 45, 198, 45, 257, 20, 257, 20, 257, 144, 198, 144"
              title="13.11.2025; 72,612722"
              alt
            />
            <area
              shape="poly"
              coords="139, 144, 139, 70, 139, 70, 198, 45, 198, 45, 198, 144, 139, 144"
              title="13.11.2024; 58,0901776"
              alt
            />
            <area
              shape="poly"
              coords="81, 144, 81, 94, 81, 94, 139, 70, 139, 70, 139, 144, 81, 144"
              title="13.11.2023; 43,5676332"
              alt
            />
            <area
              shape="poly"
              coords="22, 144, 22, 119, 22, 119, 81, 94, 81, 94, 81, 144, 22, 144"
              title="13.11.2022; 29,0450888"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 20, 257, 20, 22, 119, 22, 119, 22, 144, 257, 144"
              title="13.11.2021; 14,5225444"
              alt
            />
            <area
              shape="poly"
              coords="198, 144, 198, 45, 198, 45, 257, 20, 257, 20, 257, 144, 198, 144"
              title="13.11.2025; 72,612722"
              alt
            />
            <area
              shape="poly"
              coords="139, 144, 139, 70, 139, 70, 198, 45, 198, 45, 198, 144, 139, 144"
              title="13.11.2024; 58,0901776"
              alt
            />
            <area
              shape="poly"
              coords="81, 144, 81, 94, 81, 94, 139, 70, 139, 70, 139, 144, 81, 144"
              title="13.11.2023; 43,5676332"
              alt
            />
            <area
              shape="poly"
              coords="22, 144, 22, 119, 22, 119, 81, 94, 81, 94, 81, 144, 22, 144"
              title="13.11.2022; 29,0450888"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 20, 257, 20, 22, 119, 22, 119, 22, 144, 257, 144"
              title="13.11.2021; 14,5225444"
              alt
            />
            <area
              shape="poly"
              coords="198, 144, 198, 45, 198, 45, 257, 20, 257, 20, 257, 144, 198, 144"
              title="13.11.2025; 72,612722"
              alt
            />
            <area
              shape="poly"
              coords="139, 144, 139, 70, 139, 70, 198, 45, 198, 45, 198, 144, 139, 144"
              title="13.11.2024; 58,0901776"
              alt
            />
            <area
              shape="poly"
              coords="81, 144, 81, 94, 81, 94, 139, 70, 139, 70, 139, 144, 81, 144"
              title="13.11.2023; 43,5676332"
              alt
            />
            <area
              shape="poly"
              coords="22, 144, 22, 119, 22, 119, 81, 94, 81, 94, 81, 144, 22, 144"
              title="13.11.2022; 29,0450888"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 20, 257, 20, 22, 119, 22, 119, 22, 144, 257, 144"
              title="13.11.2021; 14,5225444"
              alt
            />
            <area
              shape="poly"
              coords="198, 144, 198, 45, 198, 45, 257, 20, 257, 20, 257, 144, 198, 144"
              title="13.11.2025; 72,612722"
              alt
            />
            <area
              shape="poly"
              coords="139, 144, 139, 70, 139, 70, 198, 45, 198, 45, 198, 144, 139, 144"
              title="13.11.2024; 58,0901776"
              alt
            />
            <area
              shape="poly"
              coords="81, 144, 81, 94, 81, 94, 139, 70, 139, 70, 139, 144, 81, 144"
              title="13.11.2023; 43,5676332"
              alt
            />
            <area
              shape="poly"
              coords="22, 144, 22, 119, 22, 119, 81, 94, 81, 94, 81, 144, 22, 144"
              title="13.11.2022; 29,0450888"
              alt
            />
          </map>
        </div>
        <div class="legend">
          <ul>
            <li class="without">Poraba brez izvedenih ukrepov</li>
            <li class="with">Poraba z izvedenimi ukrepi</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.data .icon .SS {
  background-position: -438px -380px;
}
</style>